import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SendToMeasuredMutationVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  showBlueprintDimension?: Types.InputMaybe<Types.Scalars['Int']>;
  epilogue?: Types.InputMaybe<Types.EpilogueInput>;
  allowQuestionComments?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type SendToMeasuredMutation = { __typename?: 'Mutation', sendToMeasured?: { __typename?: 'SendToMeasuredPayload', successful: boolean, validations?: { __typename?: 'ValidationsExamGeneral', general?: Array<{ __typename?: 'ValidationsMessage', message: string }> | null } | null, error?: { __typename?: 'MeasuredResponseError', name: string, code: number, message: string } | null } | null };

export const SendToMeasuredDocument = gql`
    mutation SendToMeasured($id: Int!, $showBlueprintDimension: Int, $epilogue: EpilogueInput, $allowQuestionComments: Boolean) {
  sendToMeasured(
    id: $id
    showBlueprintDimension: $showBlueprintDimension
    epilogue: $epilogue
    allowQuestionComments: $allowQuestionComments
  ) {
    successful
    validations {
      general {
        message
      }
    }
    error {
      name
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendToMeasuredGQL extends Apollo.Mutation<SendToMeasuredMutation, SendToMeasuredMutationVariables> {
    document = SendToMeasuredDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }